module.exports = __webpack_public_path__ + "static/media/success-alert.f98ea885.png";